/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-state */
import { Button, Col, Layout, Row } from 'antd';
import propTypes from 'prop-types';
import { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import MenueItems from './MenueItems';
import { GiHamburgerMenu } from 'react-icons/gi';
import { BiEnvelope, BiBell } from 'react-icons/bi';
import { logOut } from '../redux/authentication/actionCreator';
import { Link, useNavigate } from 'react-router-dom';

import { FooterStyle, LayoutContainer, SmallScreenAuthInfo } from './Style';
import AuthInfo from '../components/utilities/auth-info/info';

const { theme } = require('../config/theme/themeVariables');
const { Header, Sider, Content } = Layout;

// Wrapper Component to inject useNavigate inside Class Component
const withNavigate = (ComponentToWrap) => {
  return (props) => {
    const navigate = useNavigate();
    return <ComponentToWrap {...props} navigate={navigate} />;
  };
};

const ThemeLayout = (WrappedComponent) => {
  class LayoutComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        collapsed: false,
        hide: true,
        searchHide: true,
        customizerAction: false,
        activeSearch: false,
      };
      this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      this.updateDimensions();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions() {
      this.setState({
        collapsed: window.innerWidth <= 1200 && true,
      });
    }

    // Sign Out Handler (Arrow function keeps 'this' bound correctly)
    SignOut = (e) => {
      e.preventDefault();
      const { logOutAction, navigate } = this.props;
      if (logOutAction) {
        logOutAction(() => {
          navigate('/');
        });
      }
    };

    render() {
      const { collapsed, hide } = this.state;
      const { layoutMode, rtl, topMenu } = this.props;

      const left = !rtl ? 'left' : 'right';
      const toggleCollapsed = () => {
        this.setState({
          collapsed: !collapsed,
        });
      };

      const toggleCollapsedMobile = () => {
        if (window.innerWidth <= 990) {
          this.setState({
            collapsed: !collapsed,
          });
        }
      };

      const SideBarStyle = {
        margin: '63px 0 0 0',
        padding: `${!rtl ? '20px 20px 55px 0' : '20px 0 55px 20px'}`,
        overflowY: 'auto',
        height: '100vh',
        position: 'fixed',
        [left]: 0,
        zIndex: 988,
      };

      const renderView = ({ style }) => {
        const customStyle = {
          marginRight: 'auto',
          [rtl ? 'marginLeft' : 'marginRight']: '-17px',
        };
        return <div style={{ ...style, ...customStyle }} />;
      };

      const renderThumbVertical = ({ style }) => {
        const { ChangeLayoutMode } = this.props;
        const thumbStyle = {
          borderRadius: 6,
          backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
          [left]: '2px',
        };
        return <div style={{ ...style, ...thumbStyle }} />;
      };

      const renderThumbHorizontal = ({ style }) => {
        const { ChangeLayoutMode } = this.props;
        const thumbStyle = {
          borderRadius: 6,
          backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
        };
        return <div style={{ ...style, ...thumbStyle }} />;
      };

      return (
        <LayoutContainer>
          <Layout className="layout">
            <Header
              style={{
                position: 'fixed',
                width: '100%',
                top: 0,
                [!rtl ? 'left' : 'right']: 0,
              }}
            >
              <div className="ninjadash-header-content d-flex align-center-v justify-content-between">
                <div className="ninjadash-header-content__left d-flex align-center-v">
                  <div className="navbar-brand d-flex align-center-v">
                    <Link
                      className={
                        topMenu && window.innerWidth > 991
                          ? 'ninjadash-logo top-menu main-logo'
                          : 'ninjadash-logo main-logo'
                      }
                      to="/admin"
                    >
                      <span className="main-logo-img">
                        <img src={require(`../static/img/hbims-logo-new.jpeg`)} alt="Logo" />
                      </span>
                      <div className="logo-text">
                        <span className="logo-text-title">HBIMS-NAF&SA™</span>
                        <span className="logo-text-subtitle">
                          NATIONAL ADMISSION FRAMEWORK <br /> & SEAT ASSURANCE PROGRAMME
                        </span>
                      </div>
                    </Link>

                    {!topMenu || window.innerWidth <= 991 ? (
                      <div className="hamburger-circle">
                        <Button type="link" onClick={toggleCollapsed} style={{ padding: 0 }}>
                          <GiHamburgerMenu
                            size={20}
                            style={{ color: 'var(--brand-maroon, #330804)' }}
                          />
                        </Button>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="ninjadash-header-content__center d-flex align-center-v justify-content-center">
                  <div className="compass-icon">
                    <img
                      src={require(`../static/img/dashboard/compass.svg`).default}
                      alt="compass"
                    />
                  </div>
                  <div className="header-tagline-text">
                    <h2 className="header-tagline">
                      Discipline in action. <br />
                      Excellence in every admission.
                    </h2>
                  </div>
                </div>

                <div className="ninjadash-header-content__right d-flex align-center-v">
                  <div className="right-subtagline text-right">
                    <span className="brand-name">HBIMS-NAF&SA™</span>
                    <span className="sub-desc">Guiding Future. Securing Careers.</span>
                  </div>

                  <div className="ninjadash-nav-actions">
                    <AuthInfo />
                  </div>
                </div>
              </div>
            </Header>

            <div className="ninjadash-header-more">
              <Row>
                <Col md={0} sm={24} xs={24}>
                  <div className="ninjadash-header-more-inner">
                    <SmallScreenAuthInfo hide={hide}>
                      <AuthInfo rtl={rtl} />
                    </SmallScreenAuthInfo>
                  </div>
                </Col>
              </Row>
            </div>

            <Layout>
              {!topMenu || window.innerWidth <= 991 ? (
                <ThemeProvider theme={theme}>
                  <Sider
                    width={280}
                    style={SideBarStyle}
                    collapsed={collapsed}
                    theme={layoutMode === 'lightMode' ? 'light' : 'dark'}
                  >
                    <Scrollbars
                      className="custom-scrollbar"
                      autoHide
                      autoHideTimeout={500}
                      autoHideDuration={200}
                      renderThumbHorizontal={renderThumbHorizontal}
                      renderThumbVertical={renderThumbVertical}
                      renderView={renderView}
                      renderTrackVertical={(props) => (
                        <div {...props} className="ninjadash-track-vertical" />
                      )}
                    >
                      <MenueItems topMenu={topMenu} toggleCollapsed={toggleCollapsedMobile} />
                      {!collapsed && (
                        <Button className="crm-support-btn" block onClick={this.SignOut}>
                          <div className="crm-support-wrapper">
                            <span className="crm-phone-icon">☎️</span>

                            <div className="crm-support-content">
                              <div className="crm-support-title">
                                <span>CRM Administrator Support</span>
                              </div>
                              <span className="crm-support-subtitle">
                                Need help? Contact our team
                              </span>
                            </div>
                          </div>
                        </Button>
                      )}
                    </Scrollbars>
                  </Sider>
                </ThemeProvider>
              ) : null}

              <Layout className="atbd-main-layout">
                <Content>
                  <WrappedComponent {...this.props} />
                  <FooterStyle className="admin-footer">
                    <p>
                      HBIMS-NAF&SA™ - A controlled framework for Maritime aspirants - National
                      Admission Framework & Seat Assurance Programme.{' '}
                    </p>
                    <p>
                      {' '}
                      © {new Date().getFullYear()} National Admission Framework & Seat Assurance
                      Programme. All rights reserved.
                    </p>
                  </FooterStyle>
                </Content>
              </Layout>
            </Layout>
          </Layout>
          {window.innerWidth <= 991 ? (
            <span
              className={collapsed ? 'ninjadash-shade' : 'ninjadash-shade show'}
              onClick={toggleCollapsed}
            />
          ) : (
            ''
          )}
        </LayoutContainer>
      );
    }
  }

  const mapStateToProps = (state) => {
    return {
      layoutMode: state.ChangeLayoutMode.mode,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  };

  // Dispatch Action Bind Karein
  const mapDispatchToProps = (dispatch) => {
    return {
      logOutAction: (callback) => dispatch(logOut(callback)),
    };
  };

  LayoutComponent.propTypes = {
    layoutMode: propTypes.string,
    rtl: propTypes.bool,
    topMenu: propTypes.bool,
    logOutAction: propTypes.func,
  };

  // withNavigate aur mapDispatchToProps dono add kiye gaye hain
  return connect(mapStateToProps, mapDispatchToProps)(withNavigate(LayoutComponent));
};

export default ThemeLayout;
